var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "#717173",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C12 8.67281 9.70594 10.8853 6.75 11.2087V12C6.75 12.1989 6.67098 12.3897 6.53033 12.5303C6.38968 12.671 6.19891 12.75 6 12.75C5.80109 12.75 5.61032 12.671 5.46967 12.5303C5.32902 12.3897 5.25 12.1989 5.25 12V10.5C5.25 10.3011 5.32902 10.1103 5.46967 9.96967C5.61032 9.82902 5.80109 9.75 6 9.75C8.48156 9.75 10.5 8.06812 10.5 6C10.5 3.93187 8.48156 2.25 6 2.25C3.51844 2.25 1.5 3.93187 1.5 6C1.5 6.19891 1.42098 6.38968 1.28033 6.53033C1.13968 6.67098 0.948912 6.75 0.75 6.75C0.551088 6.75 0.360322 6.67098 0.21967 6.53033C0.0790178 6.38968 0 6.19891 0 6C0 3.105 2.69156 0.75 6 0.75C9.30844 0.75 12 3.105 12 6ZM6 15C5.70333 15 5.41332 15.088 5.16665 15.2528C4.91997 15.4176 4.72771 15.6519 4.61418 15.926C4.50065 16.2001 4.47094 16.5017 4.52882 16.7926C4.5867 17.0836 4.72956 17.3509 4.93934 17.5607C5.14912 17.7704 5.41639 17.9133 5.70736 17.9712C5.99834 18.0291 6.29994 17.9994 6.57403 17.8858C6.84811 17.7723 7.08238 17.58 7.2472 17.3334C7.41203 17.0867 7.5 16.7967 7.5 16.5C7.5 16.1022 7.34196 15.7206 7.06066 15.4393C6.77936 15.158 6.39782 15 6 15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faqIcon.d4182f175a4cd4d65d25667e33ba8043.svg";
export { ForwardRef as ReactComponent };